/**
 * Demo placeholder: deterministic 7-day usage (0–1) per connection until usage APIs exist.
 *
 * @param {string} seed Row id or toolkit slug
 * @returns {number[]}
 */
export function getConnectionUsageLast7Days(seed) {
  const s = String(seed ?? '')
  let h = 0
  for (let i = 0; i < s.length; i += 1) {
    h = (Math.imul(31, h) + s.charCodeAt(i)) | 0
  }
  const base = Math.abs(h)

  return Array.from({ length: 7 }, (_, day) => {
    const mix = (base ^ (day * 2654435761)) >>> 0
    const wave = 0.35 + 0.65 * ((mix % 1000) / 1000)
    const trend = 0.85 + 0.15 * (day / 6)
    return Math.min(1, Math.max(0.08, wave * trend))
  })
}
